import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';
import './Navigation.css';

function Navigation({ theme, toggleTheme }) {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="nav-links">
        <button 
          className="theme-toggle" 
          onClick={toggleTheme}
          aria-label="Toggle dark mode"
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
        <Link 
          to="/" 
          className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
        >
          Home
        </Link>
        <Link 
          to="/blog" 
          className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}
        >
          Blog
        </Link>
        <Link 
          to="/about" 
          className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
        >
          About
        </Link>
        <Link 
          to="/faq" 
          className={`nav-link ${location.pathname === '/faq' ? 'active' : ''}`}
        >
          FAQ
        </Link>
        <Link 
          to="/roadmap" 
          className={`nav-link ${location.pathname === '/roadmap' ? 'active' : ''}`}
        >
          Roadmap
        </Link>
        {/* <Link 
          to="/privacy" 
          className={`nav-link ${location.pathname === '/privacy' ? 'active' : ''}`}
        >
          Privacy
        </Link> */}
      </div>
    </nav>
  );
}

export default Navigation; 